import { useCallback, useState } from 'react';

import { useHistory } from 'react-router-dom';

import resetLogo from 'assets/img/password-reset-logo.png';

import { SetNewPasswordPayload, useAuthSession } from 'modules/auth-session';

import { Button, TextField } from '@material-ui/core';

import NibButton from 'components/common/NibButton/NibButton';
import NibPasswordInput from 'components/common/NibPasswordInput';

const PasswordResetPage = () => {
  const history = useHistory();

  const params = new URLSearchParams(window.location.search);
  const tokenParam = params?.get('token');
  const emailParam = params?.get('email');

  const { resetPasswordHandler, setNewPasswordHandler } = useAuthSession();

  const [email, setEmail] = useState('');
  const [isPasswordReset, setIsPasswordReset] = useState<boolean>(false);
  const [newPassword, setNewPassword] = useState('');

  const onReset = useCallback(async () => {
    if (email) {
      const result = await resetPasswordHandler({ email });
      setIsPasswordReset(result);
    }
  }, [email]);

  const onChangePassword = useCallback(async () => {
    if (newPassword) {
      const payload: SetNewPasswordPayload = {
        token: tokenParam || '',
        password: newPassword,
        email: emailParam || '',
      };
      const result = await setNewPasswordHandler(payload);
      if (result) {
        history.push('/login');
      }
    }
  }, [newPassword]);

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="flex flex-col items-center justify-start w-[410px] h-[470px] bg-appGradient-2 rounded-xl shadow-appShadow">
        <img className="mt-[-100px]" src={resetLogo} alt="logo" />
        <p className="font-semibold text-[22px] uppercase mb-5 mt-[-18px]">
          {tokenParam ? 'Set new password' : 'Forgot password?'}
        </p>
        {!tokenParam && (
          <p className="text-center text-white/30 mx-[30px]">
            Enter your email address below, and we’ll send you an email allowing you to reset it.
          </p>
        )}
        <div className="w-full flex flex-col items-center justify-center px-[30px] mt-[30px]">
          {isPasswordReset ? (
            <div className="mt-[60px] text-[25px]">Email for password reset sent successfully!</div>
          ) : (
            <>
              {tokenParam ? (
                <NibPasswordInput
                  value={newPassword}
                  onChange={(value: string) => setNewPassword(value)}
                  label=""
                  placeholder="Set a password"
                  className="!w-full"
                />
              ) : (
                <TextField
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  placeholder="Email"
                  variant="outlined"
                  fullWidth={true}
                />
              )}

              {tokenParam ? (
                // @ts-ignore
                <NibButton
                  className="!bg-appThemeColor !text-appThemeTextColor !h-[55px] !my-[35px] !rounded-[10px] !uppercase !text-[18px] !font-medium"
                  mui
                  variant="outlined"
                  size="large"
                  label="Change password"
                  onClick={onChangePassword}
                  fullWidth={true}
                />
              ) : (
                // @ts-ignore
                <NibButton
                  className="!bg-appThemeColor !text-appThemeTextColor !h-[55px] !my-[35px] !rounded-[10px] !uppercase !text-[18px] !font-medium"
                  mui
                  variant="outlined"
                  size="large"
                  label="Reset password"
                  onClick={onReset}
                  fullWidth={true}
                />
              )}
              <Button
                className="!font-normal !text-base !underline"
                variant="text"
                onClick={() => {
                  history.push('/login');
                }}
              >
                Cancel
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PasswordResetPage;
